module.exports = {
      id: "ic-100-index-v-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-100-index-v-usage",
      toString: function () {
        return this.url;
      }
    }